import { render, staticRenderFns } from "./allianceIntroductionApproval.vue?vue&type=template&id=a0562350&scoped=true&"
import script from "./allianceIntroductionApproval.vue?vue&type=script&lang=js&"
export * from "./allianceIntroductionApproval.vue?vue&type=script&lang=js&"
import style0 from "./allianceIntroductionApproval.vue?vue&type=style&index=0&id=a0562350&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0562350",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0562350')) {
      api.createRecord('a0562350', component.options)
    } else {
      api.reload('a0562350', component.options)
    }
    module.hot.accept("./allianceIntroductionApproval.vue?vue&type=template&id=a0562350&scoped=true&", function () {
      api.rerender('a0562350', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/allianceIntroductionApproval/allianceIntroductionApproval.vue"
export default component.exports